<template>
  <div class="introduction-chapter" :class="{ isFinished: isFinished }">
    <div class="introduction-chapter--header">
      <div
        class="introduction-chapter--header__mark"
        v-if="isFinished && showFinsihedMark"
      ></div>
      <div class="introduction-chapter--header__number">{{ number }}</div>
      <div class="introduction-chapter--header__vertical"></div>
      <div
        class="introduction-chapter--header__text"
        v-html="rawHtmlText"
      ></div>
    </div>
    <div class="introduction-chapter--tip" v-if="rawHtmlTip">
      <div class="introduction-chapter--tip__envelop"></div>
      <div class="introduction-chapter--tip__text" v-html="rawHtmlTip"></div>
      <div class="introduction-chapter--tip__icon" @click="showModal"></div>
    </div>
    <div class="introduction-chapter--container">
      <div
        v-if="imgConfigList[0] && imgConfigList[0].img"
        class="introduction-chapter--container__img"
        :style="{ backgroundImage: 'url(' + imgConfigList[0].img + ')' }"
      ></div>
      <div
        class="introduction-chapter--container__text"
        v-if="showDetailSteps"
        @click="openDetailSteps"
      >
        详细步骤
        <i class="introduction-chapter--container__text__icon"></i>
      </div>
    </div>
    <award-modal :visible.sync="showAwardModal" :awardInfo="awardInfo" />
  </div>
</template>
<script>
import { lx } from '@/analytic/index';
import { env } from '@/common/env';
import AwardModal from './AwardModal.vue';
import { lxConfig } from '@/analytic/guideConfig';
export default {
  props: {
    number: {
      type: Number,
      default: 1
    },
    text: {
      type: String,
      default: ''
    },
    isFinished: {
      type: Boolean,
      default: false
    },
    rawHtmlTip: {
      type: String,
      default: ''
    },
    rawHtmlText: {
      type: String,
      default: ''
    },
    imgConfigList: {
      type: Array,
      default: () => []
    },
    awardInfo: {
      type: String,
      default: ''
    },
    showDetailSteps: {
      type: Boolean,
      default: true
    },
    showFinsihedMark: {
      type: Boolean,
      default: true
    }
  },
  components: {
    AwardModal
  },
  data() {
    return {
      showAwardModal: false
    };
  },
  created() {
    // 奖励区mv
    if (this.rawHtmlTip) {
      lx.mv(
        lxConfig.mv_reward,
        {
          from: env.from
        },
        {
          cid: lxConfig.pv
        }
      );
    }
    // 详细步骤mv
    if (this.showDetailSteps) {
      lx.mv(
        lxConfig.mv_detail_step,
        {
          from: env.from
        },
        {
          cid: lxConfig.pv
        }
      );
    }
  },
  methods: {
    showModal() {
      this.showAwardModal = true;
      lx.mc(
        lxConfig.mc_reward,
        {
          from: env.from
        },
        {
          cid: lxConfig.pv
        }
      );
    },
    openDetailSteps() {
      this.$emit('openDetailSteps');
    }
  }
};
</script>
<style scoped lang="less">
@import '../../../styles/fn.less';
.introduction-chapter {
  margin: 0 auto;
  &--header {
    border-radius: 1rem 0.235rem 0.235rem 1rem;
    background-image: linear-gradient(270deg, #ffffff 0%, #d2edff 99%);
    min-width: 3rem;
    height: 0.95rem;
    display: flex;
    align-items: center;
    padding-left: 0.1rem;
    position: relative;
    &__mark {
      position: absolute;
      top: -0.26rem;
      left: 50%;
      transform: translateX(-50%);
      width: 0.97rem;
      height: 0.34rem;
      .bg-image-auto(
        'https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/finished-mark-20220411.png'
      );
    }
    &__number {
      font-family: PingFangSC-Medium;
      font-size: 0.36rem;
      color: #222222;
      letter-spacing: 0;
      font-weight: 500;
      line-height: 0.5rem;
    }
    &__vertical {
      margin: auto 0.1rem;
      opacity: 0.4;
      width: 0.01rem;
      height: 0.59rem;
      .border-right(#616161);
    }
    &__text {
      font-family: PingFangSC-Medium;
      font-size: 0.21rem;
      color: #222222;
      line-height: 0.37rem;
      font-weight: 500;
      flex: 1;
    }
  }
  &--tip {
    background: #ffffff;
    display: flex;
    align-items: center;
    width: 2.4rem;
    height: 0.38rem;
    padding-left: 0.18rem;
    margin: 0.18rem auto 0.26rem;
    border-radius: 0.2rem;
    &__envelop {
      width: 0.24rem;
      height: 0.28rem;
      .bg-image-auto(
        'https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/red-envelop-guide-20220407.png'
      );
    }
    &__text {
      opacity: 0.8;
      font-family: PingFangSC-Medium;
      font-size: 0.2rem;
      color: #222222;
      line-height: 0.28rem;
      font-weight: 500;
      padding: 0 0.07rem;
    }
    &__icon {
      width: 0.21rem;
      height: 0.21rem;
      .bg-image-auto(
        'https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/guide-attention-20220407.png'
      );
    }
  }
  &--container {
    margin: 0.3rem auto 0;
    background: #f8f8f9;
    border: 1px solid #ebedf0;
    border-radius: 0.16rem;
    width: 2.48rem;
    &__img {
      border-radius: 0.16rem;
      background-size: 100% auto;
      background-repeat: no-repeat;
      .size(2.46rem, 3.8rem);
    }
    &__text {
      opacity: 0.8;
      font-family: PingFangSC-Regular;
      font-size: 0.2rem;
      color: #222222;
      font-weight: 400;
      line-height: 0.2rem;
      text-align: center;
      padding: 0.09rem 0;
      &__icon {
        display: inline-block;
        vertical-align: middle;
        width: 0.25rem;
        height: 0.25rem;
        .bg-image-auto(
          'https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/detail-steps-arrow-20220407.png'
        );
      }
    }
  }
}
.isFinished {
  .introduction-chapter--header {
    background-image: linear-gradient(
      270deg,
      #f0f9fe 0%,
      #ffffff 54%,
      #ffffff 99%
    );
    .introduction-chapter--header__number {
      color: #1176d1;
    }
    .introduction-chapter--header__vertical {
      &::before {
        background-color: #1176d1;
      }
    }
  }
}
</style>
